import {useShallow} from 'zustand/react/shallow';
import {useReportStore} from '../../../useReportStore';
import useSourcesExplorerStore from './useSourcesExplorerStore';
import useSourcesFileViewerStore from '../../../../../stores/useSourcesFileViewerStore';

export const useSourcesReportPanelState = () => useReportStore(
    useShallow((state) => ({
        reportId: state.id || state.reportId,
        showFilters: state.showFilters,
        setShowFilters: state.setShowFilters,
        unifiedSourceScope: state.unifiedSourceScope,
        setUnifiedSourceScope: state.setUnifiedSourceScope,
        unifiedSearchMode: state.unifiedSearchMode,
        setUnifiedSearchMode: state.setUnifiedSearchMode,
        searchPassageContext: state.searchPassageContext,
        setSearchPassageContext: state.setSearchPassageContext,
        productTypes: state.productTypes,
        setProductTypes: state.setProductTypes,
        searchId: state.searchId,
        setSearchId: state.setSearchId,
    }))
);

export const useSourcesExplorerDataState = () => useSourcesExplorerStore(
    useShallow((state) => ({
        inputValue: state.inputValue,
        debouncedQuery: state.debouncedQuery,
        activeView: state.activeView,
        sources: state.sources,
        connectionState: state.connectionState,
        isLoading: state.isLoading,
        error: state.error,
        warning: state.warning,
        isStale: state.isStale,
        searchResults: state.searchResults,
        searchMeta: state.searchMeta,
        isSearching: state.isSearching,
        searchError: state.searchError,
        scopeCounts: state.scopeCounts,
        isScopeCounting: state.isScopeCounting,
    }))
);

export const useSourcesExplorerActions = () => useSourcesExplorerStore(
    useShallow((state) => ({
        setInputValue: state.setInputValue,
        setDebouncedQuery: state.setDebouncedQuery,
        setActiveView: state.setActiveView,
        setSources: state.setSources,
        setConnectionState: state.setConnectionState,
        setIsLoading: state.setIsLoading,
        setError: state.setError,
        setWarning: state.setWarning,
        setIsStale: state.setIsStale,
        setSearchResults: state.setSearchResults,
        setIsSearching: state.setIsSearching,
        setSearchError: state.setSearchError,
        clearSearch: state.clearSearch,
        setScopeCounts: state.setScopeCounts,
        setIsScopeCounting: state.setIsScopeCounting,
    }))
);

export const useSourcesViewerState = () => useSourcesFileViewerStore(
    useShallow((state) => ({
        selectedFileId: state.fileId,
        selectedFileSourceViewKey: state.sourceViewKey,
    }))
);

export const useSourcesViewerActions = () => useSourcesFileViewerStore(
    useShallow((state) => ({
        isFileViewerOpen: state.isOpen,
        openFileViewer: state.open,
        setViewerFile: state.setFile,
        closeFileViewer: state.close,
    }))
);
